export const VEHICLE = Object.freeze({
  CAR: 'car',
  MOTO: 'moto',
  TRAILER: 'trailer',
  HEAVY_MOTO: 'heavy_moto',
  MICRO_ELECTRIC_BIKE: 'micro_electric_bike',
});

export const OIL = Object.freeze({
  GAS92: 'gas92',
  GAS95: 'gas95',
  GAS98: 'gas98',
  DIESEL: 'diesel',
});

export const VEHICLE_NAME = Object.freeze({
  [VEHICLE.CAR]: '汽車',
  [VEHICLE.MOTO]: '機車',
  [VEHICLE.TRAILER]: '拖車',
  [VEHICLE.HEAVY_MOTO]: '大型重型機車',
  [VEHICLE.MICRO_ELECTRIC_BIKE]: '微型電動二輪車',
});

export const ENERGY_SOURCE_NAME = {
  fuel: '純油車',
  electric: '純電車',
  fuel_electric: '油電混合車',
} as const;
